"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Select_1 = __importDefault(require("@material-ui/core/Select"));
var InputLabel_1 = __importDefault(require("../InputLabel"));
var FormHelperText_1 = __importDefault(require("../Form/FormHelperText"));
var Input_1 = __importDefault(require("../Input"));
var MenuItem_1 = __importDefault(require("../MenuItem"));
var FormControl_1 = __importDefault(require("../Form/FormControl"));
var styles_1 = require("../../styles");
var useStyles = (0, styles_1.makeStyles)(function (theme) { return ({
    formFull: {
        width: '100%'
    },
    formControl: {
        maxWidth: '100%'
    },
    label: {
        fontSize: theme.typography.caption.fontSize,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    select: {
        fontSize: theme.typography.caption.fontSize
    },
    selectDefault: {
        paddingBottom: theme.spacing(0.5),
        paddingTop: theme.spacing(0.5)
    },
    selectMenu: {
        paddingTop: 0,
        paddingBottom: 0
    }
}); });
var Select = function (_a) {
    var _b;
    var _c, _d, _e;
    var _f = _a.classes, classes = _f === void 0 ? { select: {}, formControl: {} } : _f, _g = _a.autoWidth, autoWidth = _g === void 0 ? false : _g, defaultValue = _a.defaultValue, _h = _a.displayEmpty, displayEmpty = _h === void 0 ? false : _h, IconComponent = _a.IconComponent, id = _a.id, inputProps = _a.inputProps, _j = _a.label, label = _j === void 0 ? null : _j, labelId = _a.labelId, _k = _a.labelWidth, labelWidth = _k === void 0 ? 0 : _k, _l = _a.MenuProps, MenuProps = _l === void 0 ? {} : _l, _m = _a.native, native = _m === void 0 ? false : _m, onChange = _a.onChange, onClose = _a.onClose, onOpen = _a.onOpen, open = _a.open, renderValue = _a.renderValue, SelectDisplayProps = _a.SelectDisplayProps, value = _a.value, _o = _a.variant, variant = _o === void 0 ? 'standard' : _o, fullWidth = _a.fullWidth, _p = _a.helperText, helperText = _p === void 0 ? '' : _p, _q = _a.disabled, disabled = _q === void 0 ? false : _q, startAdornment = _a.startAdornment, endAdornment = _a.endAdornment, placeholder = _a.placeholder, field = _a.field, _r = _a.items, items = _r === void 0 ? [] : _r, _s = _a.error, error = _s === void 0 ? false : _s, _t = _a.readOnly, readOnly = _t === void 0 ? false : _t, _u = _a.children, children = _u === void 0 ? null : _u, multiple = _a.multiple;
    var internalClasses = useStyles();
    var _v = MenuProps.classes, muiProsClasses = _v === void 0 ? {} : _v;
    return (react_1.default.createElement(FormControl_1.default, { classes: __assign(__assign({}, classes.formControl), { root: (0, classnames_1.default)((_c = classes.formControl) === null || _c === void 0 ? void 0 : _c.root, (_b = {},
                _b[internalClasses.formFull] = fullWidth,
                _b[internalClasses.formControl] = !fullWidth,
                _b)) }), error: error },
        label ? (react_1.default.createElement(InputLabel_1.default, { classes: { root: internalClasses.label } }, label)) : null,
        react_1.default.createElement(Select_1.default, { classes: __assign(__assign({}, classes.select), { root: (0, classnames_1.default)(internalClasses.select, (_d = classes.select) === null || _d === void 0 ? void 0 : _d.root), select: (0, classnames_1.default)(internalClasses.selectDefault, (_e = classes.select) === null || _e === void 0 ? void 0 : _e.select) }), input: react_1.default.createElement(Input_1.default, { id: field, readOnly: readOnly, disabled: disabled }), autoWidth: autoWidth, defaultValue: defaultValue, displayEmpty: displayEmpty, IconComponent: IconComponent, id: id, inputProps: inputProps, label: label, labelId: labelId, labelWidth: labelWidth, placeholder: placeholder, MenuProps: __assign(__assign({}, MenuProps), { classes: __assign(__assign({}, muiProsClasses), { list: (0, classnames_1.default)(muiProsClasses.list || '', internalClasses.selectMenu) }) }), native: native, onChange: onChange, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, value: value, variant: variant, fullWidth: fullWidth, error: error, readOnly: readOnly, multiple: multiple, startAdornment: startAdornment, endAdornment: endAdornment }, children || items.map(function (item) { return (react_1.default.createElement(MenuItem_1.default, { key: item.key, value: item.key }, item.value)); })),
        helperText && react_1.default.createElement(FormHelperText_1.default, null, helperText)));
};
exports.default = Select;
